import { FoundationsCheckBoxType } from '../Types/FoundationsTypes'
function FoundationsCheckBox(props: FoundationsCheckBoxType) {
    return (
        <>
            <div style={{ marginTop: '0.4rem' }} className={props.containerClasses}>
                <input
                    type="checkbox"
                    className={props.inputClasses + ' foundations-checkbox'}
                    id={props.id}
                    value={props.value}
                    name={props.name}
                    checked={props.checked}
                    onChange={props.onChange}
                    disabled={props.disabled}
                    style={{ marginTop: '1.5px', minWidth: '3px!important' }}
                    data-hash={props.hash}
                />
                <label
                    className={props.labelClasses}
                    style={{ position: 'relative' }}
                    id={props.id + '_label'}
                >
                    <span className={props.labelClasses + ' d-inline'}>{props.labelText}</span>
                    <label
                        htmlFor={props.id}
                        className="col-11 error field-validation-error d-block pl-0"
                        style={{ position: 'absolute' }}
                    ></label>
                </label>
                {props.toolTipText != undefined ? (
                    <span className="text-right mt-1 tooltip-icons">
                        <span
                            id={props.id}
                            style={{
                                transform: 'translate(30%, 10%)',
                                fontWeight: 'bold',
                            }}
                            className="info-icon"
                            title={props.toolTipText}
                            data-hasqtip="0"
                            aria-describedby="qtip-0"
                        >
                            &#9432;
                        </span>
                    </span>
                ) : (
                    <></>
                )}
            </div>
        </>
    )
}

export { FoundationsCheckBox }

{
    /* <div class="{{class}}">
    <input type="checkbox" class="{{input_class}} foundations-checkbox" id={{id}} value="{{value}}" name="{{name}}"
        {{ischecked}} {{#if (isEqual disabled true)}}disabled{{/if}} style="margin-top: 1.5px; min-width:13px!important" data-hash="{{hash}}"
        data-collection_index='{{collection_index}}'>
    <label class="{{label_class}}" style="position: relative;" id="{{id}}_label">

        <span class="{{text_class}} d-inline">{{label}}</span>
        <label for="{{id}}" class="col-11 error field-validation-error d-block pl-0"
            style="position: absolute;"></label>

    </label>

    {{#if (notEqual is_tool_tip.length 0)}}
        <span class="text-right mt-1 tooltip-icons">
            <span id="{{tool_tip_img_id}}" style="transform: translate(30%, 10%); font-weight:bold;" class="info-icon" title='{{{tool_tip_text}}}' data-hasqtip="0" aria-describedby="qtip-0">&#9432;</span>
        </span>
    {{/if}}
</div> */
}
